const routes = {
  "/": "Home",
  "/dashboard": "Dashboard",
  "/sales/upload": "Bill-Wise Upload",
  "/sales/summery": "Sales Summary",
  "/paymt/receive": "Receive Payment",
  "/sales/register": "Sales Register",
  "/sales/upload": "Bill-Wise Upload",
  "/purchase/upload": "Purchase Upload",
  "/sales/summery": "Sales Summary",
  "/sales/pmthis": "Payment History",
  "/sales/acclist": "Bank Accounts",
  "/paymt/due": "Payent Due",
  "/settings/expense": "Expense Management",
  "/reports/dayBook": "Day Book",
  "/reports/loadingSheet": "Loading Sheet",
  "/masters/saleInsert": "Sale Invoice",
  "/masters/stockDetails": "Stock Details",
  "/masters/partyDetails": "Party Details",
  "/masters/partyDue": "Party Due",
  "/paymt/beatDue": "Beat Payment Due",
  "/sales/invoieUpload": "Invoice Upload",
  "/masters/partyUpload": "Master Party Upload",
  "/masters/rateUpload": "Master Rate Upload",
  "/masters/assetsLiabilities": "Assets and Liabilities",
  "/masters/documents": "Document Center",
  "/masters/investors": "Loan Accounts",
  "/masters/recurringSetup": "Recurring Setup",
  "/reports/chequeDetails": "Cheque Details",
  "/vehicles/upload": "Vehicles Number Upload",
  "/dues/verification": "Dues Verification By Orders",
  "/masters/emailSyncCenter": "Email Sync Center",
  "/cash/details": "Cash Details Center",
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js